<template>
  <cytomine-modal :active="active" :title="$t('create-new-folder')" @close="close">
    <div class="modal-form-content">
      <div class="form-section">
        <label class="form-label">{{ $t('folder-name') }}</label>
        <b-input 
          v-model="name" 
          :placeholder="$t('enter-descriptive-folder-name')"
          required
          ref="nameInput"
          @keyup.enter="createImageGroup"
        ></b-input>
        <p class="help-text">{{ $t('folder-name-help') }}</p>
      </div>
    </div>

    <template #footer>
      <button class="button is-outlined" type="button" @click="close">{{ $t('button-cancel') }}</button>
      <button 
        class="button is-primary" 
        @click="createImageGroup" 
        :disabled="!name.trim()"
        :loading="isCreating"
      >
        {{ $t('button-create-folder') }}
      </button>
    </template>
  </cytomine-modal>
</template>

<script>
import CytomineModal from '../utils/CytomineModal.vue';

export default {
  name: 'AddImageGroupModal',
  components: {
    CytomineModal
  },
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      name: '',
      isCreating: false
    };
  },
  watch: {
    active(val) {
      if (val) {
        this.name = '';
        this.isCreating = false;
        this.$nextTick(() => {
          if (this.$refs.nameInput) {
            this.$refs.nameInput.focus();
          }
        });
      }
    }
  },
  methods: {
    createImageGroup() {
      if (!this.name.trim()) return;
      
      this.isCreating = true;
      this.$emit('create', this.name.trim());
      this.$emit('update:active', false);
    },
    close() {
      this.$emit('update:active', false);
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/dark-variables.scss';

.modal-form-content {
  padding: 0.35rem 0.15rem 0.15rem;
}

.form-section {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.form-label {
  color: $dark-text-primary;
  font-size: 0.86rem;
  font-weight: 700;
}

.help-text {
  color: $dark-text-disabled;
  font-size: 0.78rem;
  line-height: 1.4;
  margin-top: 0.2rem;
}
</style>
